import { Helmet } from "react-helmet-async";

const BASE_URL = "https://www.estancialaalameda.com";
const DEFAULT_TITLE = "Estancia La Alameda — Hotel Boutique en Chascomús, Buenos Aires";
const DEFAULT_DESCRIPTION =
  "Estancia La Alameda — Hotel boutique en Chascomús con glamping, día de campo, restaurante y eventos a orillas de la laguna. Reserva tu escapada rural.";
const DEFAULT_IMAGE = `${BASE_URL}/logo192.png`;

const SEO = ({ title, description, path = "/", image }) => {
  const fullTitle = title ? `${title} | Estancia La Alameda` : DEFAULT_TITLE;
  const fullDescription = description || DEFAULT_DESCRIPTION;
  const fullUrl = `${BASE_URL}${path}`;
  const fullImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={fullImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
};

export default SEO;
